<footer class="main-footer">
  <div class="container-fluid d-flex justify-content-between small">
    <span>
      &copy; 2019. <a href="javascript:;" translate>APP_NAME</a> by
      <a href="https://2kvisiongroup.com/" target="_blank">2K Vision Group</a>
    </span>
    <span class="text-dark">v1.0.0</span>
  </div>
</footer>
